var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafeBoxPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1406 0H2.85938V22.5H5.67188V24H7.07812V22.5H16.9219V24H18.3281V22.5H21.1406V0ZM19.7344 1.40625V18.2812H4.26562V1.40625H19.7344ZM4.26562 21.0938V19.6875H19.7344V21.0938C16.7284 21.0938 7.27866 21.0938 4.26562 21.0938Z",
    fill: "#07689F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9219 2.8125H7.07812V8.4375H16.9219V2.8125ZM15.5156 7.03125H8.48438V4.21875H15.5156V7.03125Z",
    fill: "#07689F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 15.4688H9.89062V16.875H8.48438V15.4688Z",
    fill: "#07689F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2969 15.4688H12.7031V16.875H11.2969V15.4688Z",
    fill: "#07689F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 12.6562H9.89062V14.0625H8.48438V12.6562Z",
    fill: "#07689F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2969 12.6562H12.7031V14.0625H11.2969V12.6562Z",
    fill: "#07689F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1094 15.4688H15.5156V16.875H14.1094V15.4688Z",
    fill: "#07689F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1094 12.6562H15.5156V14.0625H14.1094V12.6562Z",
    fill: "#07689F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 9.84375H9.89062V11.25H8.48438V9.84375Z",
    fill: "#07689F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2969 9.84375H12.7031V11.25H11.2969V9.84375Z",
    fill: "#07689F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1094 9.84375H15.5156V11.25H14.1094V9.84375Z",
    fill: "#07689F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeBoxPrimary);
export default __webpack_public_path__ + "static/media/safe-box-primary.2d35ed8a.svg";
export { ForwardRef as ReactComponent };